var $ = jQuery;

function go() {
	window.dataLayer = window.dataLayer | [];
	$(".full-length-videos .image-link, .full-length-videos .text-link").click(function() {
		var videoTitle = $(this).closest(".vertical-video-tile").attr("data-videoId")+" - "+$(this).closest(".vertical-video-tile").attr("data-cleanVideoTitle");
		var action = "ImageLink";
		if ($(this).hasClass("text-link")) action = "TextLink";
		window.dataLayer.push({
			'event': action,
			'event_category': 'WatchWholeVideo',
			'event_label': videoTitle
		});
	});
}

module.exports = go;